// packages/sdk/config/src/index.ts
import * as defs from "@dxos/protocols/proto/dxos/config";

// packages/sdk/config/src/config.ts
import { boolean } from "boolean";
import defaultsDeep from "lodash.defaultsdeep";
import get from "lodash.get";
import set from "lodash.set";
import { InvalidConfigError } from "@dxos/errors";
import { schema } from "@dxos/protocols";
var configRootType = schema.getCodecForType("dxos.config.Config");
var mapFromKeyValues = (spec, values) => {
  const config = {};
  for (const [key, { path, type }] of Object.entries(spec)) {
    let value = values[key];
    if (value !== void 0) {
      if (type) {
        switch (type) {
          case "boolean": {
            value = boolean(value);
            break;
          }
          case "number": {
            value = Number(value);
            break;
          }
          case "string": {
            break;
          }
          case "json": {
            value = value ? JSON.parse(value) : null;
            break;
          }
          default: {
            throw new Error(`Invalid type: ${type}`);
          }
        }
      }
      set(config, path, value);
    }
  }
  return config;
};
var mapToKeyValues = (spec, values) => {
  const config = {};
  for (const [key, { path, type }] of Object.entries(spec)) {
    const value = get(values, path);
    if (value !== void 0) {
      switch (type) {
        case "json":
          config[key] = JSON.stringify(value);
          break;
        default:
          config[key] = value;
      }
    }
  }
  return config;
};
var validateConfig = (config) => {
  if (!("version" in config)) {
    throw new InvalidConfigError("Version not specified");
  }
  if ((config == null ? void 0 : config.version) !== 1) {
    throw new InvalidConfigError(`Invalid config version: ${config.version}`);
  }
  const error = configRootType.protoType.verify(config);
  if (error) {
    throw new InvalidConfigError(error);
  }
  return config;
};
var Config = class {
  /**
  * Creates an immutable instance.
  * @constructor
  * @param objects
  */
  constructor(config = {}, ...objects) {
    this._config = validateConfig(defaultsDeep(config, ...objects, {
      version: 1
    }));
  }
  /**
  * Returns an immutable config JSON object.
  */
  get values() {
    return this._config;
  }
  /**
  * Returns the given config property.
  *
  * @param key A key in the config object. Can be a nested property with keys separated by dots: 'services.signal.server'.
  * @param defaultValue Default value to return if option is not present in the config.
  * @returns The config value or undefined if the option is not present.
  */
  get(key, defaultValue) {
    return get(this._config, key, defaultValue);
  }
  /**
  * Returns config key without type checking.
  *
  * @deprecated Use the type-checked version.
  */
  getUnchecked(key, defaultValue) {
    return get(this._config, key, defaultValue);
  }
  /**
  * Returns the given config property or throw if it doesn't exist.
  *
  * @param key A key in the config object. Can be a nested property with keys separated by dots: 'services.signal.server'.
  */
  getOrThrow(key) {
    const value = get(this._config, key);
    if (!value) {
      throw new Error(`Config option not present: ${key}`);
    }
    return value;
  }
};

// packages/sdk/config/src/loaders/browser.js
import { log } from "@dxos/log";
var CONFIG_ENDPOINT = "/.well-known/dx/config";
var LocalStorage = (item = "options") => JSON.parse(window.localStorage.getItem(item) || "{}");
var Dynamics = async () => {
  const { publicUrl = "", dynamic } = __DXOS_CONFIG__;
  if (!dynamic) {
    log("dynamics disabled", __CONFIG_DYNAMICS__);
    return __CONFIG_DYNAMICS__;
  }
  log("fetching config...", { publicUrl });
  return await fetch(`${publicUrl}${CONFIG_ENDPOINT}`).then((res) => res.json()).catch((error) => {
    log.warn("Failed to fetch dynamic config.", error);
    return {};
  });
};
var Envs = () => {
  return __CONFIG_ENVS__;
};
var Defaults = () => {
  return __CONFIG_DEFAULTS__;
};

// packages/sdk/config/src/types.ts
var FILE_DEFAULTS = "defaults.yml";
var FILE_ENVS = "envs-map.yml";
var FILE_DYNAMICS = "config.yml";
export {
  Config,
  Defaults,
  Dynamics,
  Envs,
  FILE_DEFAULTS,
  FILE_DYNAMICS,
  FILE_ENVS,
  LocalStorage,
  defs,
  mapFromKeyValues,
  mapToKeyValues,
  validateConfig
};
//# sourceMappingURL=index.mjs.map
